module.exports = __webpack_public_path__ + "static/media/mira_search_principle_angle.fa14a174.png";